import React, { useState, useEffect, useMemo } from "react";
import "./FrequentGuests.css";
import config from "../config";

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

const FrequentGuests = () => {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${config.BASE_URL}/api/guest-insights/frequent-guests`,
          { headers: config.getHeaders() }
        );
        if (!res.ok) throw new Error("Unable to fetch frequent guests");
        const data = await res.json();
        setGuests(data);
      } catch (e) {
        console.error(e);
        setGuests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchGuests();
  }, []);

  const filteredGuests = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return guests;
    return guests.filter(
      (g) =>
        g.customerName?.toLowerCase().includes(query) ||
        g.customerContactNumber?.includes(query) ||
        g.resortNames?.some((r) => r.toLowerCase().includes(query))
    );
  }, [guests, search]);

  return (
    <div className="frequent-guests-wrapper">
      <h2
        className="page-title"
        style={{
          fontSize: "24px",
          fontWeight: 700,
          color: "var(--text-dark)",
          textAlign: "left",
          margin: "12px 0 18px",
          paddingLeft: "10px",
          borderLeft: "4px solid var(--primary-teal)",
        }}
      >
        Frequent Guests
      </h2>

      <div className="frequent-guests-filters">
        <input
          type="text"
          className="frequent-guests-search"
          placeholder="Search by name, phone, or property..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="frequent-guests-table">
        <table>
          <thead>
            <tr>
              <th>Guest Name</th>
              <th>Phone</th>
              <th>Visits</th>
              <th>Properties Visited</th>
              <th>Last Visit</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : filteredGuests.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No repeat guests found.
                </td>
              </tr>
            ) : (
              filteredGuests.map((g) => (
                <tr key={g.customerContactNumber}>
                  <td>{g.customerName}</td>
                  <td>{g.customerContactNumber}</td>
                  <td>
                    <span className="frequent-guests-visit-badge">
                      {g.visitCount}
                    </span>
                  </td>
                  <td>{g.resortNames?.join(", ")}</td>
                  <td>{formatDate(g.lastVisitDate)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FrequentGuests;
